module.exports = __webpack_public_path__ + "static/media/gt-icon.c30dfbd7.svg";